export default __webpack_public_path__ + "img/logo.44bd6aea9a4004015ec3d229248792cc.svg";